import { jsxs, jsx } from 'react/jsx-runtime';
import { Colors } from '../../../theme/Colors.es.js';
import { Heading } from '../../display/Heading/Heading.es.js';
import { HeadingLevel } from '../../display/Heading/HeadingLevel.es.js';
import { LegacyButton } from '../../navigation/LegacyButton/Button.es.js';
import { TextColorMap } from './constants.es.js';
import { getCtaBtnColor } from './utils.es.js';
import { LegacyColorMap } from '../../../theme/LegacyColorMap.es.js';

const root = "_root_1cc1l_1";
const heading = "_heading_1cc1l_20";
const subHeading = "_sub-heading_1cc1l_47";
const description = "_description_1cc1l_58";
const ctaContainer = "_cta-container_1cc1l_71";
const styles = {
	root: root,
	heading: heading,
	subHeading: subHeading,
	description: description,
	ctaContainer: ctaContainer
};

const getTextColor = (bgColor) => {
  const mappedColor = TextColorMap[bgColor];
  return Colors[LegacyColorMap[mappedColor]];
};
const getButton = (props) => {
  const btnProps = {
    children: props.ctaText,
    href: props.ctaHref,
    onClick: props.onCtaClick,
    onKeyDown: props.onCtaKeyDown,
    target: props.ctaTarget,
    "data-testid": "cta-button"
  };
  const btnColor = getCtaBtnColor(props.bgColor, props.ctaBtnColor);
  return jsx(LegacyButton, Object.assign({}, btnProps, {
    // "primary-alt" no longer exists as of V8 and is now mapped to "primary"
    color: btnColor === "primary-alt" ? "primary" : btnColor,
    size: "large"
  }));
};
const CTATextContent = (props) => {
  const textColor = getTextColor(props.bgColor);
  return jsxs("div", { className: styles.root, "data-align": props.alignment || "left", style: {
    "--_zds-cta-text-content-text-color": textColor
  }, "data-zds": true, children: [jsxs(HeadingLevel, { children: [jsx(Heading, { className: styles.heading, children: props.heading }), props.subHeading && jsx(HeadingLevel, { children: jsx(Heading, { className: styles.subHeading, children: props.subHeading }) })] }), props.description && jsx("div", { className: styles.description, "data-align": props.alignment, "data-zds": true, children: props.description }), props.ctaText && (props.ctaHref || props.onCtaClick) && jsx("div", { className: styles.ctaContainer, "data-zds": true, children: getButton(props) })] });
};

export { CTATextContent };
//# sourceMappingURL=CTATextContent.es.js.map
